import * as React from "react"
import { useSignal } from "@preact/signals-react"
import {Box, Grid, Typography} from "@mui/material"
import { AccordionSeeker } from "@ui-seeker/core"

import { retailer } from "@signals"
import { useAdminProductReviewValidateSite } from "./@hooks"
import { AdminProductReviewRetailerSelected } from "../@signals"
import { RetailerSelect, ValidateSiteButton } from "./@components"


export default function AdminProductReviewValidateSiteAccordion() {
    const { optionsSelect, isLoading, handleSubmitValidateSite, handleSetOptionsSelect } = useAdminProductReviewValidateSite()
    const isOpen = useSignal(false)

    if (AdminProductReviewRetailerSelected.value?.length !== 1 ) return <></>

    return <AccordionSeeker
        title="Mapping Site"
        expanded={isOpen.value}
        onChange={e => isOpen.value = !isOpen.value}
        sx={{ mb: 2 }}
    >
        <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>Once you validate, you are validating all the product data from the sites below until the day
            selected
        </Typography>

        <Grid container spacing={2}>
            <Grid item xs={10}>
                <RetailerSelect
                    onFinishAjax={handleSetOptionsSelect}
                    optionsSelect={optionsSelect}
                />
            </Grid>

            <Grid item xs={2}>
                <ValidateSiteButton handleClick={handleSubmitValidateSite} isLoading={isLoading}/>
            </Grid>
        </Grid>
    </AccordionSeeker>
}